export default "__VITE_ASSET__ba493c5e__"